var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20334 15.4976V8.66764H7.5075L7.85 5.99347H5.20334V4.29014C5.20334 3.51847 5.41834 2.99014 6.52584 2.99014H7.92917V0.605974C7.24637 0.5328 6.56004 0.497468 5.87334 0.500141C3.83667 0.500141 2.43834 1.74347 2.43834 4.02597V5.98848H0.14917V8.66264H2.44334V15.4976H5.20334Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.08294b6cc5bc0999f6380facd1893301.svg";
export { ForwardRef as ReactComponent };